module.exports = __webpack_public_path__ + "img/vertical_7_1_7005.c634fd1d.png";